export const notifications = {
  Direct: "Direto",
  footer: {
    from_the_last_30_days: "dos últimos 30 dias.",
    That_s_all_your_notifications: "Essas são todas as suas notificações",
  },
  Last_Week: "Semana Passada",
  Mark_all_as_read: "Marcar todas como lidas",
  Notifications: "Notificações",
  Older: "Mais antigas",
  Product: "Produto",
  Show_unread_only: "Mostrar apenas não lidas",
  Today: "Hoje",
  Yesterday: "Ontem",
} as const;
